import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tag } from 'antd';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';
import { fetchPayzeProviders, downloadPayzeProvider } from '../../actions/payzeProviderAction';

const PayzeProvider = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const payzeProviders = useSelector(({ payzeProvider }) => payzeProvider.payzeProviders);
  const currentProject = useSelector(({ project }) => project.currentProject);
  const isLoaded = useSelector(({ payzeProvider }) => payzeProvider.isLoaded);

  const onDownloadCsv = () => {
    dispatch(downloadPayzeProvider());
  };

  const mapToTable = (payzeProviders) => {
    const data = [];

    payzeProviders?.forEach(
      ({ _id, createdAt, amount, status, userId, externalTransactionId }, index) => {
        data.push({
          amount,
          created: formatDate(createdAt),
          externalTransactionId,
          id: _id,
          key: index,
          status,
          userId
        });
      }
    );

    return data;
  };

  const columns = [
    {
      dataIndex: 'id',
      key: 'id',
      render: (id) => {
        return <Copy text={id} />;
      },
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'ID'
    },
    {
      dataIndex: 'userId',
      key: 'userId',
      render: (userId) => {
        return <Copy text={userId} />;
      },
      sorter: (a, b) => a.userId.toString().localeCompare(b.userId),
      title: 'User ID'
    },
    {
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => {
        return <Copy text={amount} />;
      },
      sorter: (a, b) => a.amount.toString().localeCompare(b.amount),
      title: 'Amount'
    },
    {
      dataIndex: 'externalTransactionId',
      key: 'externalTransactionId',
      render: (externalTransactionId) => {
        return <Copy text={externalTransactionId} />;
      },
      sorter: (a, b) => a.externalTransactionId.toString().localeCompare(b.externalTransactionId),
      title: 'External Transaction ID'
    },
    {
      dataIndex: 'created',
      key: 'created',
      render: (created) => {
        return <Copy text={created} />;
      },
      sorter: (a, b) => new Date(a.created) - new Date(b.created),
      title: 'Created'
    },
    {
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let style = {};
        switch (status) {
          case 'Committed':
            style = {
              backgroundColor: 'rgba(65, 204, 156, 0.15)',
              border: 'none',
              color: '#41CC9C',
              width: '90%'
            };
            break;
          case 'Rejected':
            style = {
              backgroundColor: 'rgba(255, 71, 108, 0.15)',
              border: 'none',
              color: '#FF476C',
              width: '90%'
            };
            break;
          default:
            break;
        }

        return (
          <Tag key={status} style={style}>
            {status}
          </Tag>
        );
      },
      sorter: (a, b) => a.status.localeCompare(b.status),
      title: <div>Status</div>
    }
  ];

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download .CSV',
      type: 'primary'
    }
  ];

  useEffect(() => {
    async function load() {
      dispatch(fetchPayzeProviders());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const data = mapToTable(payzeProviders);

  if (!currentProject) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="Payze Provider" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        loading={isLoaded}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default PayzeProvider;
